module.exports = __webpack_public_path__ + "static/media/secure.8fe873e6.svg";